import React from "react";

/**
 * QuoteEchoCard — extracted from `PlanScreen.jsx` (issue #763, the "What you
 * told us" card) for #868/#872 (brief-g59.md, "Conformance" §): set-up step
 * 2 (`Plan.dc.html` state `set-up-step-2`) draws the SAME card — 1px
 * `--nw-line`, a 3px navy left rule, radius 12, 14px padding, "What you told
 * us" as the section label, the sentence in Manrope 700 17px ink, curly
 * quotes — with its own helper line, six px less gap (6 vs PlanScreen's 8)
 * and, per D172 S5, without the step-2 drawing's own "It starts your
 * plan." clause (PR #937 review, F4 — that sentence is `Plan.dc.html`'s
 * `set-up-step-2` state's, not PlanScreen's; PlanScreen never had it to
 * begin with, since it draws its own, different helper). It is false
 * today — PlanScreen never reads `short_term_goal` — so the walkthrough's
 * copy segment omits it rather than asserting something the app does not
 * yet do; see decisions-2026-09-24.md D172 S5.
 *
 * `helper` and `gap` are props, not a second literal card, because the two
 * hosts draw two different helper sentences and two different gaps for the
 * same shape — this component is the shape, not the words.
 *
 * `PlanScreen.jsx` keeps its own `plan-quote` testid on the call site; this
 * component takes the testid as a prop so it never hardcodes one host's id.
 */
export function QuoteEchoCard({ quote, helper, gap = 8, testId, className = "", style }) {
  return (
    <div
      className={className}
      style={{
        display: "flex",
        flexDirection: "column",
        gap,
        padding: 14,
        background: "var(--nw-surface)",
        border: "1px solid var(--nw-line)",
        borderLeft: "3px solid var(--nw-navy)",
        borderRadius: "var(--nw-radius-card)",
        ...style,
      }}
    >
      <div className="nw-section">What you told us</div>
      <div
        data-testid={testId}
        style={{
          fontFamily: "'Manrope', sans-serif",
          fontWeight: 700,
          fontSize: 17,
          lineHeight: 1.35,
          color: "var(--nw-ink)",
        }}
      >
        “{quote}”
      </div>
      <div className="nw-help">{helper}</div>
    </div>
  );
}

export default QuoteEchoCard;
